module.exports = __webpack_public_path__ + "img/buyHomeBannerPhone3.1b891cdf.png";